import { render, staticRenderFns } from "./EmpowerFooter.vue?vue&type=template&id=685d5e70&scoped=true&"
import script from "./EmpowerFooter.vue?vue&type=script&lang=js&"
export * from "./EmpowerFooter.vue?vue&type=script&lang=js&"
import style0 from "./EmpowerFooter.vue?vue&type=style&index=0&id=685d5e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d5e70",
  null
  
)

export default component.exports